import { type Property } from 'csstype';
import { type AnchorHTMLAttributes, MouseEvent } from 'react';

import { BaseTooltip } from '../BaseTooltip';
import { Subtitle, TableCellContainer, Text, TextLink } from './styles';

export type ITableCellProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'children'
> & {
  dataCy?: string;
  subtitle?: string;
  href?: string;
  text: string;
  textAlign?: Property.TextAlign;
  onClickTitle?: (event: MouseEvent<HTMLParagraphElement>) => void;
  onClickSubtitle?: (event: MouseEvent<HTMLParagraphElement>) => void;
};

export const TableCell = ({
  className,
  style,
  subtitle,
  text,
  dataCy,
  textAlign = 'center',
  onClickTitle,
  onClickSubtitle,
  ...anchorProps
}: ITableCellProps): JSX.Element => {
  return (
    <TableCellContainer
      className={className}
      style={style}
      textAlign={textAlign}
      data-cy={dataCy}
    >
      {anchorProps.href ? (
        <TextLink
          {...anchorProps}
          title={text}
          target="_blank"
          data-cy={dataCy}
        >
          {text}
        </TextLink>
      ) : (
        <BaseTooltip message={text}>
          <Text data-cy={`title-${text}`} onClick={onClickTitle}>
            {text}
          </Text>
        </BaseTooltip>
      )}

      {subtitle && (
        <BaseTooltip message={subtitle}>
          <Subtitle data-cy={`sub-title-${subtitle}`} onClick={onClickSubtitle}>
            {subtitle}
          </Subtitle>
        </BaseTooltip>
      )}
    </TableCellContainer>
  );
};
